import i18n from 'i18next';

// Locale do Intl a partir do idioma ativo do i18n (pt | en | es).
const LOCALES = { pt: 'pt-BR', en: 'en-US', es: 'es-ES' };

export function localeAtual() {
  return LOCALES[(i18n.language || 'pt').slice(0, 2)] ?? 'pt-BR';
}

const DIA_MES = { day: '2-digit', month: '2-digit' };
const DIA_MES_ANO = { day: '2-digit', month: '2-digit', year: 'numeric' };

/** Data no formato do idioma ativo (ex.: 05/10/2026 em pt, 10/05/2026 em en). */
export function formatarData(valor, opcoes = DIA_MES_ANO) {
  if (!valor) return null;
  const d = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(d.getTime())) return null;
  return new Intl.DateTimeFormat(localeAtual(), opcoes).format(d);
}

/** Período "05/10 — 20/10/2026" (ou "Até 20/10/2026" quando só há o fim), no idioma ativo. */
export function formatarPeriodo(inicio, fim) {
  if (inicio && fim) return `${formatarData(inicio, DIA_MES)} — ${formatarData(fim)}`;
  if (fim) return i18n.t('Until {{date}}', { date: formatarData(fim) });
  return null;
}

/** Valor monetário no idioma ativo (ex.: R$ 150,00 em pt, R$150.00 em en). */
export function formatarMoeda(valor, moeda = 'BRL') {
  if (valor == null || Number.isNaN(Number(valor))) return null;
  return new Intl.NumberFormat(localeAtual(), { style: 'currency', currency: moeda }).format(Number(valor));
}
